import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import { CrossSellRemoveLightBoxHeader } from './cross_sell_remove_light_box_header';
import { CrossSellRemoveLightBoxContent } from './cross_sell_remove_light_box_content';

function CrossSellRemoveLightBox(props) {
    return (
        <Lightbox
            opened={props.visible}
            onClose={props.onClose}
            additionalClassNames={['cross-sell-remove-light-box__lightbox']}
            headerIcon="icon--wheel-alignment"

        >
            <div className="cross-sell-remove-light-box">
                <CrossSellRemoveLightBoxHeader data={props.data} />
                <CrossSellRemoveLightBoxContent
                    data={props.data}
                    expanded={props.expanded}
                    error={props.error}
                    onExpand={props.onExpand}
                    onRemove={props.onRemove}
                    onAccept={props.onAccept}
                    onClose={props.onClose}
                />
            </div>
        </Lightbox>
    );
}

CrossSellRemoveLightBox.propTypes = {
    visible: PropTypes.bool.isRequired,
    expanded: PropTypes.bool.isRequired,
    error: PropTypes.object,
    onExpand: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onAccept: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { CrossSellRemoveLightBox };
